import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export interface IQueryURL {
    parse: (queryString: string) => Record<string, string>;
    assemble: (
        queryArgs: Record<string, boolean | number | string>,
        questionMarkPrefix?: boolean,
    ) => string;
}

export function injectQueryURL(container: IContainer = injectOrBuildContainer()): IQueryURL {
    return container.get<IQueryURL>(TYPES.IQueryURL);
}

export function bindQueryURL(
    val: IQueryURL,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<IQueryURL>(TYPES.IQueryURL, val);
}

export function unbindQueryURL(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IQueryURL);
}
